define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/table",
	"csi/table/Widget"
], function(declare,lang,_,table,Table) {

	return declare(Table, {
		refreshData: function() {
			// summary: for expander tables, expand what was previously expanded even on refresh
			this.captureHierarchyState();
			return this.inherited(arguments);
		},

		refreshWidget: function() {
			// summary: for expander tables, expand what was previously expanded even on refresh
			this.captureHierarchyState();
			return this.inherited(arguments);
		},

		_onChangeQueryLevels: function(/*QueryLevel[]*/queryLevels) {
			// summary: determine if view supports optimized expansion
			this.inherited(arguments);

			if (this.bSupportsExpandLevelOption === undefined) {
				this.bSupportsExpandLevelOption = _.every(queryLevels, function(ql, i) {
					// cannot auto-expand PDF if there are groups that are not set to auto-expand
					if (ql.groupSpec && !ql.bAutoExpand) {
						return false;
					}
	
					// root/main level does not use expand logic, so return true to continue checking lower levels;
					// and levels that do not display results (i.e. those used for custom view filtering) can be ignored
					if (ql.bMain || !ql.bResults || !i) {
						return true;
					}
	
					// can only auto-expand if leaf level and query is for immediate children
					if (!ql.isLeafLevel() || !ql.resultPath) {
						console.warn("csi/expander/Widget - not applicable to this view: " + this.defView.m_id);
						return false;
					}
	
					return true;
				}, this);
			}
		}
	});
});
